import request from '../utils/request.js'

export default {
	getList(params) {
		return request.post(`project/lists`, params).then(res => res.data);
	},
	add(params) {
		return request.post(`project/add`, params).then(res => res.data);
	},
	edit(params) {
		return request.post(`project/add`, params).then(res => res.data);
	},
	details(params) {
		return request.post(`project/details`, params).then(res => res.data);
	},
	delete(params) {
		return request.post(`project/del`, params).then(res => res.data);
	},
	getTemplateField(params){
		return request.post(`project/get_template_fields`, params).then(res => res.data);
	},
	selectList(params) {
		return request.post(`project/selectlist`, params).then(res => res.data);
	},
	getRecentProjects(params) {
		return request.post(`project/recent`, params).then(res => res.data);
	},
	getDomains(params) {
		return request.post(`project/getDomains`, params).then(res => res.data);
	},
	
}


// WEBPACK FOOTER //
// ./src/api/project.js